import { useEffect, useMemo, useRef, useState } from "react";
import {
  useFileUploadMutation,
  useGetNursingHomeLocationsQuery,
  useGetPracticeLocationsQuery,
} from "../../services/chatService";
import { useGroupChatContext } from "../../context/groupchatContext";
import { AdvanceSelect } from "../../components/reactHookFormFields/advanceSelectField";
import { PageDialogContent, PageDialogFooter } from "../../components/dialog";
import { useForm } from "react-hook-form";
import { BtnComponent } from "../../components/button";
import { TextAreaField } from "../../components/reactHookFormFields/textAreaFields";
import { useBroadcastLocationMessageMutation } from "../../services/appService";
import { toast } from "react-toastify";
import DwtPopup from "../../components/dwtNew/dwtPopUp";
import ActionMenuList from "../../components/ActionMenuList";
import { PaperClipIcon } from "@heroicons/react/20/solid";
import AttachmentContainer from "../groupChat/attachmentContainer";
import { forEach } from "lodash";
import { FaSpinner } from "react-icons/fa";

const BroadcastMessage = ({ onCancelHandler }) => {
  const [showScannerPopup, setShowScannerPopup] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const inputRef = useRef();
  const groupChatContext = useGroupChatContext();
  const { authData } = useMemo(() => ({
    authData: groupChatContext.authData,
  }));

  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ defaultValues: {} });

  const [userLocations, setUserLocations] = useState([]);

  const { data: providerLocations } = useGetPracticeLocationsQuery(
    { only_my_locations: 1 },
    { skip: !authData?.is_provider }
  );
  const { data: nursingHomeLocations } = useGetNursingHomeLocationsQuery({
    skip: authData?.is_provider,
  });

  useEffect(() => {
    if (authData?.is_provider) {
      setUserLocations(providerLocations);
    } else {
      setUserLocations(nursingHomeLocations);
    }
  }, [providerLocations, nursingHomeLocations]);

  const onChangeLocation = (data) => {};

  const [broadcastLocationMessage, { isLoading: isBroadcastingMsg }] =
    useBroadcastLocationMessageMutation();

  const onSubmitForm = async (data) => {
    const payload = {
      location: data.locations?.map((location) => location.id)?.join(","),
      message: {
        type: "event",
        event_type: "broadcast_message",
        text: data.message,
      },
    };
    if(attachedFiles.length){
        payload.message.media = attachedFiles;
    }

    const res = await broadcastLocationMessage(payload);
    if (res?.data?.code == 0) {
      toast.success("Message broadcasted successfully");
      onCancelHandler();
    }
  };

  const onRemoveFile = (index) => {
    setAttachedFiles(attachedFiles.filter((_, i) => i !== index));
  };
  const [fileUpload, { isLoading: isUploadingFile }] = useFileUploadMutation();
  const fileUploadFunction = (formData, type) => {
    fileUpload(formData).then((res) => {
      if (res?.data?.code === 0) {
        setAttachedFiles((prevAttachment) => {
          const newArray = [...prevAttachment, res.data.data];
          return newArray;
        });
        if (type == "scanner") {
          setShowScannerPopup(false);
        }
      } else {
        toast.error(res?.data?.msg);
      }
    });
  };
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    forEach(files, (file) => {
      const formData = new FormData();
      formData.append("file", file);
      fileUploadFunction(formData);
    });
    event.target.value = null;
  };

  return (
    <>
      <PageDialogContent>
        <h1>Broadcast Message</h1>
        <form id="broadcast_msg_form" onSubmit={handleSubmit(onSubmitForm)}>
          <div className="text-black flex flex-col gap-2">
            <AdvanceSelect
              title="Location"
              onChangeHandler={(data) => {
                onChangeLocation(data);
              }}
              control={control}
              setValue={setValue}
              name="locations"
              optionData={userLocations}
              showLabel="name"
              rules={{
                required: { value: true, message: "Location is required" },
              }}
              errors={errors}
            />
            <div className="relative">
              {showScannerPopup && (
                <DwtPopup
                  showScannerPopup={showScannerPopup}
                  fileUploadFunction={fileUploadFunction}
                  setFileFromScanner={setAttachedFiles}
                  setShowScannerPopup={setShowScannerPopup}
                />
              )}
              <div className="relative">
                <TextAreaField
                  title="Message"
                  name="message"
                  rows="4"
                  control={control}
                  rules={{
                    required: { value: attachedFiles.length ? false : true, message: "Message is required" },
                  }}
                  errors={errors}
                />
                <div className="absolute bottom-2 left-2 right-2 pointer-events-none">
                 
                  <div className="pointer-events-auto">
                    <div className="flex justify-end items-center gap-2 ">
                      <ActionMenuList
                        icon={
                          <PaperClipIcon className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600" />
                        }
                        title=""
                        // menuItemStyle="left-0 self-end"
                        position="up"
                        menuList={[
                          {
                            label: "Upload File",
                            onClick: () => inputRef?.current?.click(),
                          },
                          {
                            label: "Scan Document",
                            onClick: () => {
                              setShowScannerPopup(true);
                            },
                          },
                        ]}
                      />
                      <input
                        ref={inputRef}
                        id="fileInput"
                        type="file"
                        className="hidden"
                        onChange={handleFileChange}
                        multiple
                      />
                    </div>
                  </div>
                </div>
              </div>
              {attachedFiles.length > 0 || isUploadingFile && (
                        <div className="mb-2 p-1 bg-white rounded border border-gray-200">
                            <FaSpinner className="animate-spin text-gray-400" size={16} />
                        </div>
                    )}
              {attachedFiles.length > 0 && (
                      <div className="mb-2 p-1 bg-white rounded border border-gray-200">
                        <AttachmentContainer
                          data={{ files: attachedFiles }}
                          onRemoveFile={onRemoveFile}
                          isLoading={isUploadingFile}
                        />
                      </div>
                    )}
            </div>
          </div>
        </form>
      </PageDialogContent>
      <PageDialogFooter>
        <BtnComponent
          text="Close"
          btnType="default"
          onClick={onCancelHandler}
        />
        <BtnComponent
          text="Broadcast"
          btnType={authData.is_provider ? "primary" : "primary_theme"}
          form="broadcast_msg_form"
          type="submit"
          loading={isBroadcastingMsg}
        />
      </PageDialogFooter>
    </>
  );
};

export default BroadcastMessage;
